// extracted by mini-css-extract-plugin
module.exports = {"arrowWrapper":"_b220c54","withTag":"_7d2bd12","arrowBody":"_5ef66a4","arrowPointer":"_91edd5a","navigationContainer":"_a23b1be"};